import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import { toast } from 'react-toastify';
import { getGhollakMinBalance } from 'services/ghollak.routes';
import queryString from 'utils/queryString';
import GhollakMinBalanceTable from './GhollakMinBalanceTable';
import { useSearchParams } from 'react-router-dom';
import moment from 'jalali-moment';

export default function GhollakMinBalance() {
    const [searchParams] = useSearchParams()
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [ghollakMinBalance, setGhollakMinBalance] = useState([]);
    const [trigger, setTrigger] = useState(null);
    const [searchInfo, setSearchInfo] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [calculateDetail, setCalculateDetail] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        setSearchInfo({ ...searchInfo, [name]: value });
    };
    const dateHandleChange = (value, name) => {
        setSearchInfo({
            ...searchInfo,
            [name]: value ? moment(value, 'jYYYY/jM/jD').format('YYYY-M-D') : null
        });
    };
    const firstRender = useRef(true);

    useEffect(() => {
        if (
            firstRender.current &&
            searchParams.get("investmentOpportunityId")
        ) {
            firstRender.current = false;
            return;
        }
        firstRender.current = false;

        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            per_page: 20,
            ghollak_id: searchInfo.ghollak_id || null,
            investment_opportunity_id: searchInfo.investment_opportunity_id || null,
            from_for_date: searchInfo.from_for_date || null,
            to_for_date: searchInfo.to_for_date || null,
        };
        getGhollakMinBalance(queryString(query), trigger !== null, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
            }
            if (page !== 0) {
                setGhollakMinBalance((prev) => [...prev, ...data.data]);
            } else {
                setGhollakMinBalance(data.data);
            }
            setCalculateDetail({
                days_counted: data?.days_counted,
                annual_rate: data?.annual_rate,
            });
            if (
                searchInfo.from_for_date &&
                searchInfo.to_for_date &&
                searchInfo.investment_opportunity_id
            )
                setIsSubmitted(true);
            setLoading(false);
            setCursor(data?.meta?.next_cursor === null ? "" : data?.meta?.next_cursor);
            setHasMore(data?.meta?.next_cursor !== null);
        });
    }, [page, trigger]);

    const onFilterClick = () => {
        setPage(0);
        setCursor('');
        setTrigger(Math.random());
    }
    const onClearFilterClick = () => {
        setSearchInfo({})
        onFilterClick()
    }
    useEffect(() => {
        if (searchParams.get("investmentOpportunityId")) {
            if (page === 0)
                setTrigger(Math.random());
            else
                setPage(0);

            setSearchInfo({ investment_opportunity_id: searchParams.get("investmentOpportunityId") })
            setCursor(null);
        }
    }, [searchParams.get("investmentOpportunityId")]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={ghollakMinBalance.length} next={fetchMoreData} hasMore={hasMore}>
                <GhollakMinBalanceTable calculateDetail={calculateDetail} onClearFilterClick={onClearFilterClick} isSubmitted={isSubmitted} data={ghollakMinBalance} filterInfo={searchInfo} setSearchInfo={setSearchInfo} handleFilterChange={handleChange} onFilterClick={onFilterClick} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
